import { Fragment } from "react";

const AdminLayout = ({ children }) => {
  return (
    <Fragment>
      {children}
    </Fragment>
  );
};

export default AdminLayout;
